export enum POPUP_TYPE {
  CREATOR = 'creator',
  RANKING_EVENT = 'rankingEvent',
  FAN_LETTER = 'fanLetter',
}
